import { memo } from 'react';
import { Icon } from 'src/components';
import { CONTENT_TYPE_VALUE } from 'src/constants';

interface IProps {
    contentTypes: number[];
}

export function ContentTypeIcon({ contentTypes = [] }: IProps) {
    if (contentTypes.includes(CONTENT_TYPE_VALUE.VIDEO)) {
        return <Icon type="bm" icon="video" />;
    }

    if (contentTypes.includes(CONTENT_TYPE_VALUE.PHOTO)) {
        return <Icon type="bm" icon="photo" />;
    }

    return null;
}

export default memo(ContentTypeIcon);
